var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownShortcut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#818181"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.86189 9.52851C5.12224 9.26816 5.54435 9.26816 5.8047 9.52851L9.33329 13.0571L9.33329 5.33325C9.33329 4.96506 9.63177 4.66658 9.99996 4.66658C10.3681 4.66658 10.6666 4.96506 10.6666 5.33325L10.6666 13.0571L14.1952 9.52851C14.4556 9.26816 14.8777 9.26816 15.138 9.52851C15.3984 9.78886 15.3984 10.211 15.138 10.4713L10.4714 15.138C10.211 15.3983 9.7889 15.3983 9.52856 15.138L4.86189 10.4713C4.60154 10.211 4.60154 9.78886 4.86189 9.52851Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownShortcut);
export default __webpack_public_path__ + "static/media/downShortcut.ec708d6363836bfa544da24391bfd2b4.svg";
export { ForwardRef as ReactComponent };